export const PROGRAM = "program";
export const GROUP = "group";
export const USER = "user";

export const TOAST_TIMEOUT = 3000;

export const ITEMS_PER_PAGE = 10;

export type achInputErrors = {
  counterpartyError: boolean;
  noteError: boolean;
  amountError: boolean;
};

export const ATTACHMENT_KEY = "attachmentKey";
export const ACCOUNT_NUMBER_INPUT_NAME = "account-number-input";
export const CONFIRM_ACCOUNT_NUMBER_INPUT_NAME = "confirm-account-number-input";
export const EIN_NUMBER_INPUT_NAME = "ein-number-input";
export const DOB_INPUT_NAME = "dob-input";

export type ENVConfig = {
  vgsValut: string;
  vgsEnvironment: "live" | "sandbox";
  vgsCname: string;
  ssoHost: string;
  graphqlUri: string;
};

export const APP_ENVS = [
  "production",
  "staging",
  "development",
  "local",
] as const;

export const ENVIRONMENT_CONFIGURATION: {
  [key in (typeof APP_ENVS)[number]]: ENVConfig;
} = {
  production: {
    vgsValut: "tnttrxzoyh3",
    vgsEnvironment: "live",
    vgsCname: "vgs.api.snap.app",
    ssoHost: "https://accounts.snap.app/",
    graphqlUri: "https://api.snap.app/",
  },
  staging: {
    vgsValut: "tnt00opvrzj",
    vgsEnvironment: "sandbox",
    vgsCname: "vgs.api.staging.snap.app",
    ssoHost: "https://accounts.staging.snap.app",
    graphqlUri: "https://api.staging.snap.app",
  },
  development: {
    vgsValut: "tnt00opvrzj",
    vgsEnvironment: "sandbox",
    vgsCname: "vgs.api.staging.snap.app",
    ssoHost: "https://accounts.staging.snap.app",
    graphqlUri: "https://api.staging.snap.app",
  },
  local: {
    vgsValut: "tnt00opvrzj",
    vgsEnvironment: "sandbox",
    vgsCname: "vgs.api.staging.snap.app",
    ssoHost: "http://localhost:7011",
    graphqlUri: "http://localhost:7020/graphql",
  },
} as const;

export const TIER1 = "TIER1";
export const TIER2 = "TIER2";
export const TIER3 = "TIER3";

export const TIERS = [TIER1, TIER2, TIER3] as const;